module.exports = __webpack_public_path__ + "static/media/ic_legacy_tools.e492f835.svg";